export default "## Demographics\n\nThis score shows this brand's likelihood to prefer locations with a similar demographics profile to the subject location.\n";